import { ReleaseStatusType, humanizeReleaseStatus } from '../../constants/releaseStatus';

export const getHumanizeReleaseStatus = (status: ReleaseStatusType): string => {
  return humanizeReleaseStatus[status] ?? status;
};
